import { getAxiosClient } from "../../axios-client";
import { PricelistGetByIdRequestBody, PricelistGetByIdResponse } from "./types";

const axiosClient = getAxiosClient();
export const pricelistGetById = async (body: PricelistGetByIdRequestBody) => {
  return await axiosClient.ax.post<PricelistGetByIdResponse>(
    "Warehouses/PricelistGetById",
    body
  );
};
